import { ContextHelp } from './ContextHelp';

/** Separate sibling control: help never opens a picker or selects an import method. */
export function ImportMethodHelp(props: { readonly label: string; readonly text: string }) {
  return <ContextHelp {...props} className="import-method-help" />;
}
